<section class="video-controls">
    <t-video-controls></t-video-controls>
    <me-layers-timeline-wrapper></me-layers-timeline-wrapper>
</section>